// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/shortcutKey/shortcutKey.js#1 $

/**
* @ngdoc directive
* @name tcApp.directive:tcShortcutkey
* @description
* Shortcut key directive, manages the shortcuts added and removed to shortcutkeyService
*/

angular.module('tc.shortcutkey', [])
.directive('tcShortcutkey', function($parse, $timeout, shortcutkeyService, tcShortcutkeyFilter) {
	return {
			restrict: 'A',
			link: function(scope, element, attrs) {
				var tcShortcutkey = attrs.tcShortcutkey;
				tcShortcutkey = $parse(tcShortcutkey)(scope);
				if (!tcShortcutkey) return;
				tcShortcutkey = tcShortcutkeyFilter(tcShortcutkey);
				if (tcShortcutkey === null) return;
				
				// Use a timeout so all elements are rendered in their correct container (e.g. main menu)
				$timeout(shortcutkeyService.addKey, 0, true, tcShortcutkey.toUpperCase(), attrs.id);
				
				scope.$on('$destroy', function() {
					shortcutkeyService.removeKey(tcShortcutkey.toUpperCase(), attrs.id);
				});

			}
		};

})
.filter('tcShortcutkey', function($log) {
	return function(key, parentKey) {
		key = key.toString();
		// Convert double digit numbers to A - Z
		if (!isNaN(key)) {
			var keyNumber = Number(key);
			if (keyNumber > 35) {
				// Only allow 1 - 9, A - Z
				$log.warn('Too many elements bound to shortcut key: ', (angular.isDefined(parentKey) ? parentKey : key));
				return null;
			} else if (keyNumber > 9) {
				return String.fromCharCode(65 + (keyNumber - 10));
			}
		}
		return key;
	};
});

